/**
 *格式化时间
 *yyyy-MM-dd hh:mm:ss
 */
 import { bookTypeNameMap } from "@/config/baseConfig.js"

export function formatDate(time, fmt) {
  if (time === undefined || '') {
    return;
  }
  const date = new Date(time);
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    );
  }
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
  };
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      const str = o[k] + '';
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? str : padLeftZero(str)
      );
    }
  }
  return fmt;
}

export function dateStr(value) {
  try {
    if (!value.toString().trim()) return ''
  } catch (error) {
    return ''
  }
  return formatDate(value, 'yyyy-MM-dd');
}
export function monthStr(value) {
  if (!value) return ''
  return formatDate(value, 'yyyy-MM');
}

export function monthCn(value, isShowDay) {
  return formatDate(value, isShowDay ? 'yyyy年MM月dd日' : 'yyyy年MM月');
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length);
}
/*
 * 隐藏用户手机号中间四位
 */
export function hidePhone(phone) {
  return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
}

export function simpleText(val) {
  if (val != null && val != '') {
    let reg = /[\u4e00-\u9fa5]/g;
    let names = val.match(reg);
    val = names ? names.join('') : '';
    return val;
  } else {
    return '';
  }
}


export function newSimpleText(val) {
  if(!val) return ''
  
  if (val !== null && val !== '') {
    return val.replace(/<[^>]*>/g, '');
  } else {
    return '';
  }
}

export function bookTypeName(val) {
  return bookTypeNameMap[val]
}

/**
 * 格式化价格，保留两位小数，不足时自动补充00
 * @param {number|string} price - 价格数值
 * @returns {string} 格式化后的价格字符串
 */
export function priceFormat(price) {
  if (price === null || price === undefined || price === '') {
    return '0.00';
  }
  
  // 转换为数字
  const numPrice = Number(price);
  
  // 检查是否为有效数字
  if (isNaN(numPrice)) {
    return '0.00';
  }
  
  // 格式化为两位小数
  const formattedPrice = numPrice.toFixed(2);
  
  return `${formattedPrice}`;
}



export function filterHtmlTags(text) {
  if (!text) return ''
  return text
    .replace(/<[^>]+>/g, '') // 移除所有HTML标签
    .replace(/&nbsp;/g, ' ') //   替换&nbsp;为空格
    .replace(/&lt;/g, '<') // 替换&lt;为<
    .replace(/&gt;/g, '>') // 替换&gt;为>
    .replace(/&amp;/g, '&') // 替换&amp;为&
    .replace(/&quot;/g, '"') // 替换&quot;为"
    .replace(/&apos;/g, "'") // 替换&apos;为'
    .replace(/&ldquo;/g, '“') // 替换&ldquo;为左引号"
    .replace(/&rdquo;/g, '”') // 替换&rdquo;为右引号"
    .replace(/&mdash;/g, '—') // 替换&mdash;为—
    .trim() // 移除首尾空格
}